import React from 'react';
import { SectionHeading } from './SectionHeading';
import { costRows, costTotal } from '../data/salesData';
export function CostSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg)] py-16 sm:py-20" data-id="element-31" data-mp="9e14as7w4fxm">
      <div className="mx-auto max-w-4xl px-4" data-id="element-32" data-mp="4jn1i4qwf6ix">
        <SectionHeading eyebrow="⚖️ La cuenta que nadie hace" data-id="element-33" data-mp="3vrsit1w8jb80">
          La cuenta real
        </SectionHeading>

        <div className="sales-scrollbar mt-8 overflow-x-auto pb-3" data-id="element-34" data-mp="3qsocqk4lxtlw">
          <table className="w-full min-w-[620px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--line)] text-left text-sm" data-id="element-35" data-mp="3mqueeihvx1ow">
            <thead data-id="element-36" data-mp="3hs9phf8324fr">
              <tr className="bg-[var(--surface-2)]" data-id="element-37" data-mp="3htuaad4li90f">
                <th className="p-4 font-semibold text-[var(--text)]" data-id="element-38" data-mp="3ctg7palrjr9s">Factor</th>
                <th className="p-4 font-semibold text-[var(--rose)]" data-id="element-39" data-mp="1g0wmwwtl88mv">Costo</th>
              </tr>
            </thead>
            <tbody data-id="element-40" data-mp="1b10iiwgzaf6s">
              {costRows.map((row, i) => <tr key={row.factor} className={i % 2 === 0 ? 'bg-[var(--surface)]' : 'bg-[var(--bg-alt)]'} data-id="element-41" data-mp="p7l3o6mqsvb7" data-mpi={i}>
                  <td className="border-t border-[var(--line)] p-4 font-medium text-[var(--text)]/90" data-id="element-42" data-mp="taq4m4r6coxq">
                    {row.factor}
                  </td>
                  <td className="border-t border-[var(--line)] p-4 text-[var(--text-soft)]" data-id="element-43" data-mp="k7yr7zeqnj3g">
                    {row.cost}
                  </td>
                </tr>)}
              <tr className="bg-[var(--rose-tint)]" data-id="element-44" data-mp="1cww9i2iy9fw7">
                <td className="border-t border-[var(--rose)]/40 p-4 font-bold text-[var(--text)]" data-id="element-45" data-mp="1cwmjwg1thar1">
                  {costTotal.factor}
                </td>
                <td className="border-t border-[var(--rose)]/40 p-4 font-bold text-[var(--rose)]" data-id="element-46" data-mp="136t4t52gudi1">
                  {costTotal.cost}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-serif-display text-2xl font-semibold text-[var(--text)] sm:text-3xl" data-id="element-47" data-mp="1voozdo2q2kzp">
          Tu inversión en Pilates Clinic se paga con los primeros 2 alumnos
          adaptados correctamente valorados.
        </p>
      </div>
    </section>;
}